import React, { FC } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'

interface Props extends RouteComponentProps {
  title?: JSX.Element
  img?: string
}

const LeftImageSection: FC<Props> = props => {
  const { title, img } = props
  return (
    <div className="image-container">
      <div style={{ backgroundImage: `url(${img})` }} className="left-img" />
      {title}
    </div>
  )
}

export default withRouter(LeftImageSection)
